import {
  CheckTokenRequest,
  SendPhoneNumberRequest,
} from "../../../components/molecures/PhoneInput/apis/types";
import { RepairShop } from "../../../model/RepairShop";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";
import { MESSAGE_KIND } from "../../Login/apis/constants";
import {
  CancelRepairShopRequestBody,
  RepairshopRegisterRequestBody,
} from "./types";

export const register = async (requestBody: RepairshopRegisterRequestBody) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/repair-shop/apply`,
    requestBody: { ...requestBody, service: "TIREPICK" },
  });
  return response?.data;
};
export const checkDuplicatiedId = async (queryParams: {
  repairShopAId: string;
}) => {
  const response = await httpRequest({
    method: axiosUtils.GET,
    url: `/repair-shop/${queryParams.repairShopAId}/duplication`,
  });
  return response;
};
export const sendPhoneNumber = async (props: SendPhoneNumberRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/auth-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const checkPhoneAuth = async (props: CheckTokenRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/access-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const fetchUnApprovedRepairShop = async (
  repairShopAId: string
): Promise<RepairShop> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `repair-shop`,
    queryParams: { repairShopAId },
  });
  return response?.data.row;
};
export const editUnApprovedRepairShop = async (
  requestBody: RepairshopRegisterRequestBody
) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.PUT,
    url: `repair-shop`,
    requestBody,
  });
  return response;
};
export const cancelRepairShop = async (
  requestBody: CancelRepairShopRequestBody
) => {
  await httpRequest({
    method: axiosUtils.DELETE,
    url: `/repair-shop`,
    requestBody,
  });
};
